import { render, staticRenderFns } from "./weightManagement.vue?vue&type=template&id=8dc1baa4&scoped=true&"
import script from "./weightManagement.vue?vue&type=script&lang=js&"
export * from "./weightManagement.vue?vue&type=script&lang=js&"
import style0 from "./weightManagement.vue?vue&type=style&index=0&id=8dc1baa4&prod&lang=scss&"
import style1 from "./weightManagement.vue?vue&type=style&index=1&id=8dc1baa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc1baa4",
  null
  
)

export default component.exports